<template>
  <!-- <div> -->
  <!-- 答题有奖弹窗 -->
  <div class="question-box" v-if="showQuestion">
    <div class="mask" @click="closeMask"></div>
    <div class="content">
      <div class="info">
        <template v-if="questionStep == 1">
          <div class="top"></div>
          <div class="info-title">答题有奖</div>
          <div class="title">
            {{ question.describe }}
          </div>
          <div class="select">
            <div
              @click="handleSelectAnswer(index)"
              :class="['option', { active: answerIndex === index }]"
              v-for="(item, index) in question.answers"
              :key="index"
            >
              {{ item.value }}
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="isError">
            <div class="top error" />
            <div class="info-title">答题有奖</div>
            <div class="answer-tips">答错了</div>
          </template>
          <template v-else>
            <div class="top-prize" />
            <div class="top-prize-bg" />
            <div class="answer-tips">恭喜答对了！</div>
          </template>
        </template>
        <div class="btn" @click="handleBesureAnswer">
          {{ questionStep == 1 ? "确定" : isError ? "好的" : "查看奖品" }}
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import Apis from '../../config/apis'
import _ from '../../config/util'
import { Toast } from 'mint-ui'

export default {
  props: {
    question: {
      type: Object,
    },
    uid: {
      type: [String, Number],
    },
    sid: {
      type: [String, Number],
    },
    scenic: {
      type: [String, Number],
    },
  },
  data() {
    return {
      idx: 0,
      showQuestion: false, // 答题弹窗
      questionStep: 1, // 1代表选择 2代表结果
      answerIndex: '',
      isError: '', // true为错误 false为正确
      time: 0, // 答题计时
      intervalID: '', // 计时器id
    }
  },
  computed: {
    isWeiXin() {
      return this.$store.state.isWeiXin
    },
    curScenicItem() {
      return this.$store.state.curScenicItem
    },
  },
  watch: {
    showQuestion(newVal) {
      if (newVal) {
        this.time = 0
        if (this.intervalID) clearInterval(this.intervalID)
        this.intervalID = setInterval(() => {
          this.time += 1
        }, 1000)
      }
    },
  },
  methods: {
    // 选择答题
    handleQuestion() {
      this.showQuestion = true
    },
    // 答案选择
    handleSelectAnswer(index) {
      this.answerIndex = index
    },
    handleBesureAnswer() {
      if (!this.uid) {
        Toast('您还未登录请先登录再继续')
        setTimeout(() => {
          let url = `/pages/member/login/index?redirect=/${this.scenic == 1 ? 'pages' : 'packages'}/scenic/map/index&sid=${this.sid}&scenic=${this.scenic}`
          if(this.isWeiXin){
            window.uni.miniProgram.navigateTo({
                url
            })
          } else {
            url = (this.scenic == 1 ? this.$scenicUrl : this.$baseurl) + url
            window.location.href = url
          }
        }, 1500)
        return
      }
      if (this.questionStep == 1) {
        if (!this.answerIndex && this.answerIndex !== 0) {
          Toast('请选择你的答案')
          return
        }

        clearInterval(this.intervalID) // 停止计时器
        this.axios
          .post(Apis.questionAnswer, {
            uid: this.uid,
            id: this.question.id,
            index: this.answerIndex,
            used_time: this.time,
            sid: this.curScenicItem.id
          })
          .then((res) => {
            this.isError = res.data.bool == 0
            this.questionStep = 2

            // if (!this.isError) this.$emit('selectCorrect', true)

            // 清空选择
            this.answerIndex = ''
          })
          .catch((err) => {
            console.info(err)
          })
      } else {
        this.isError ? (this.questionStep = 1) : this.toPrize()
        this.showQuestion = false
      }
    },
    // 查看奖品
    toPrize() {
      this.questionStep = 1
      // uni.navigateTo({
      //     // 传入type和id
      //     url: 'packages/treasure-hunt/mine/index?type=audio&id='
      // })

      // 仅景区通开放
      if (this.scenic != 1) return
      let url = `/pages/scenic/answer-reward/index?sid=${this.sid}&type=2`
      if (this.isWeiXin) {
        window.uni.miniProgram.navigateTo({
          url,
        })
      } else {
        url = (this.scenic == 1 ? this.$scenicUrl : this.$baseurl) + url
        window.location.href = url
      }

      // this.$router.push({name : 'My', query: {uid : this.uid, id : 1, scenic:this.scenic}})
      // if(this.isWeiXin){
      // 	window.uni.miniProgram.redirectTo({
      // 		url: '/pages/scenic/answer-reward/index?id=1'
      // 	})
      // }
      // else{
      // 	if(item.key == 'scenic'){
      // 		var url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/index/index?id=${this.sid}` : `${this.$baseurl}packages/scenic/index/index?id=${this.sid}`
      // 		window.location.href = url
      // 	}
      // 	if(item.key == 'discount'){
      // 			var url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/coupon/index?id=${this.sid}` : `${this.$baseurl}packages/scenic/coupon/index?id=${this.sid}`
      // 		window.location.href = url
      // 	}
      // 	if(item.key == 'vip'){
      // 			var url = this.scenic == 1 ? `${this.$scenicUrl}pages/scenic/vip/index?sid=${this.sid}` : `${this.$baseurl}packages/scenic/vip/index?sid=${this.sid}`
      // 		window.location.href = url
      // 	}
      // }
    },
    closeMask() {
      this.showQuestion = false
      this.answerIndex = ''
      this.questionStep = 1
      this.isError = ''
      this.time = 0
      if (this.intervalID) clearInterval(this.intervalID)
    },
  },
}
</script>

<style lang="scss" scoped>
.question-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  .mask {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    opacity: 1;
  }
  .content {
    position: absolute;
    padding: 0.12rem;
    top: 56%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: linear-gradient(0deg, #f3bc7d 0%, #fbecc1 100%);
    border-radius: 0.2rem;
    box-shadow: 0 0 0.2rem rgba(255, 255, 255, 0.5);

    background: linear-gradient(0deg, #206864 0%, #67BBA6 100%);
    box-shadow: 0 .1rem .30rem 0 rgba(41, 80, 78, 0.3);
    &.border {
      &:before,
      &:after {
        position: absolute;
        content: "";
        display: block;
        top: -0.2rem;
        width: 0.22rem;
        height: 0.2rem;
        background: #dda743;
        border-radius: 50% 50% 0 0;
      }
      &:before {
        left: 0.66rem;
      }
      &:after {
        right: 0.68rem;
      }
    }
  }
  .info {
    position: relative;
    z-index: 2;
    width: 5.4rem;
    background: #fff;
    box-shadow: 0px 0px 0.09rem 0px rgba(223, 202, 140, 0.5);
    border-radius: 0.2rem;
    padding: 1.1rem 0.4rem 0.4rem;
    box-sizing: border-box;
  }
  .top,
  .top-prize,
  .top-prize-bg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .top {
    top: -1.54rem;
    width: 4.24rem;
    height: 2.26rem;
    background: url("./../../assets/prize-answer.png");
    background-size: 100%;
    &.error {
      background: url("./../../assets/prize-answer_fail.png");
      background-size: 100%;
    }
  }
  .top-prize {
    width: 2.24rem;
    height: 2rem;
    top: -1rem;
    z-index: 2;
    background: url("./../../assets/prize-answer_success.png");
    background-size: 100%;
  }
  .top-prize-bg {
    width: 3.64rem;
    height: 1.42rem;
    bottom: calc(100% + 0.12rem);
    background: url("./../../assets/prize-answer_successBkg.png");
    background-size: 100%;
  }
  .info-title {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.36rem;
    color: #FFFFFF;
  }
  .answer-tips {
    padding: 0.9rem 0;
    text-align: center;
    font-size: 0.36rem;
    font-family: Alibaba PuHuiTi;
    color: #29504E;
  }
  .title {
    font-size: 0.28rem;
    color: #d38b24; //$text-color;
  }
  .select {
    margin: 0.6rem 0 0.4rem;
    width: 100%;
  }
  .option {
    width: 100%;
    text-align: center;
    height: 0.8rem;
    line-height: 0.8rem;
    background: #f5f5f7;
    border-radius: 0.4rem;
    margin-bottom: 0.3rem;
    font-size: 0.28rem;
    &:last-child {
      margin-bottom: 0;
    }
    &.active {
      background: #206864;
      color: #fff;
      position: relative;
      &:after {
        display: block;
        position: absolute;
        content: "";
        width: 16px;
        height: 6px;
        display: inline-block;
        border: 1px solid #fff;
        border-width: 0 0 2px 2px;
        transform: rotate(-45deg);
        vertical-align: baseline;
        right: 0.3rem;
        top: 0.26rem;
      }
    }
  }
  .btn {
    margin: auto;
    width: 2rem;
    text-align: center;
    height: 0.8rem;
    line-height: 0.8rem;
    background: linear-gradient(0deg, #9D4343 0%, #4D2020 100%);
    border-radius: 0.4rem;
    font-size: 0.28rem;
    color: #ffffff;
  }
}
</style>